module.exports = __webpack_public_path__ + "img/icon_calendar.ea56f3dd.svg";